import { toast as toast$1 } from 'react-toastify';

function toastPromise(promise, params) {
    return toast$1.promise(promise, {
        pending: params.pending ?? params.loading,
        success: params.success,
        error: typeof params.error === 'function'
            ? {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                render: ({ data }) => params.error(data),
            }
            : params.error,
    });
}
function dismiss(id) {
    toast$1.dismiss(id);
}
const toast = Object.assign((message, options) => toast$1(message, options), {
    success: toast$1.success,
    error: toast$1.error,
    info: toast$1.info,
    warning: toast$1.warning,
    promise: toastPromise,
    dismiss,
});

export { toast };
//# sourceMappingURL=toast.js.map
